import { render } from "./DownloadList.vue?vue&type=template&id=7d4c556a&scoped=true"
import script from "./DownloadList.vue?vue&type=script&lang=js"
export * from "./DownloadList.vue?vue&type=script&lang=js"

import "./DownloadList.vue?vue&type=style&index=0&id=7d4c556a&scoped=true&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4c556a"]])

export default __exports__